<div class="card oui-card">
  <div class="card-body mb-4">
    <form [formGroup]="registrationForm" *ngIf="registrationForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7">
          <app-combobox-form-control
            [parentForm]="registrationForm"
            [formControlName]="'civilityCode'"
            [title]="'Common.YourCivility' | labelText"
          >
          </app-combobox-form-control>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
          <app-name-form-control
            [parentForm]="registrationForm"
            [formControlName]="'lastName'"
            [title]="'Common.SpouseName' | labelText"
          >
          </app-name-form-control>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
          <app-name-form-control
            [parentForm]="registrationForm"
            [formControlName]="'firstName'"
            [title]="'Common.FirstName' | labelText"
          >
          </app-name-form-control>
        </div>
      </div>

      <div class="row" *ngIf="isPeri">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
          <app-date-form-control
            [parentForm]="registrationForm"
            [formControlName]="'expectedRetirementDate'"
            [title]="'Common.ExpectedRetirementDate' | labelText"
            [minDate]="expectedRetirementMinDate"
          >
          </app-date-form-control>
        </div>
      </div>

      <div class="row" *ngIf="isPeri">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
          <app-number-form-control
            [parentForm]="registrationForm"
            [formControlName]="'retirementYearsCount'"
            [title]="'Home.RetirementYearsCountTitle' | labelText"
          >
          </app-number-form-control>
        </div>
      </div>

      <div class="row registration-dob-row" [class.has-inline-error]="dobRegValueIsNotInRangeLimit">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
          <app-date-form-control
            [parentForm]="registrationForm"
            [formControlName]="'dateOfBirth'"
            [title]="'Common.DateOfBirth' | labelText"
            [maxDate]="dobMaxDate"
            [ngClass]="{ wtihManualError: dobRegValueIsNotInRangeLimit }"
          >
          </app-date-form-control>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 registration-dob-error" *ngIf="dobRegValueIsNotInRangeLimit">
          <div class="error-block">
            <span class="text"> {{ dobErrorBlockText }} </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
          <app-email-form-control
            [parentForm]="registrationForm"
            [formControlName]="'email'"
            [title]="'Common.Email' | labelText"
            (focusout)="onEmailFocusout($event)"
          >
          </app-email-form-control>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 txt-default after-input">
          {{ 'HOME.AbleToResumeAtAnyTime' | labelText }}
        </div>
      </div>

      <div class="row mt-4 mb-4">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <app-mobile-form-control
            class="error-new-row"
            [parentForm]="registrationForm"
            [formControlName]="'mobilePhone'"
            [title]="'Common.MobileNumber' | labelText"
          >
          </app-mobile-form-control>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <app-phone-form-control
            class="error-new-row"
            [parentForm]="registrationForm"
            [formControlName]="'phone'"
            [title]="'Common.PhoneNumber' | labelText"
          >
          </app-phone-form-control>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 txt-default after-input">
          {{ 'HOME.MobilePhoneIsMandatory' | labelText }}
        </div>
      </div>

      <div class="row mt-5" *ngIf="!isContract">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8">
          <app-checkbox-form-control
            class="big-text mt-0"
            [title]="'Home.OKToReceivePromotionalOffersByEmail' | labelText"
            [parentForm]="registrationForm"
            [formControlName]="'receiveEmail'"
          >
          </app-checkbox-form-control>
        </div>
      </div>

      <div class="row" *ngIf="!isContract">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8">
          <app-checkbox-form-control
            class="big-text mt-0"
            [title]="'Home.OKToReceivePromotionalOffersByText' | labelText"
            [parentForm]="registrationForm"
            [formControlName]="'receiveSms'"
          >
          </app-checkbox-form-control>
        </div>
      </div>
    </form>
  </div>

  <div class="warning">
    {{ 'HOME.GatherDocumentsToFinalizeSubcription' | labelText }}
  </div>
</div>
